(function () {
	if (window.__etProductTabsInit) return;
	window.__etProductTabsInit = true;

	document.addEventListener('click', function (event) {
		var tab = event.target.closest('.et-product-tabs__tab');
		if (!tab) return;

		var root = tab.closest('.et-product-tabs');
		if (!root) return;

		var index = tab.getAttribute('data-tab-index');

		root.querySelectorAll('.et-product-tabs__tab').forEach(function (t) {
			var isActive = t === tab;
			t.classList.toggle('is-active', isActive);
			t.setAttribute('aria-selected', isActive ? 'true' : 'false');
		});

		root.querySelectorAll('.et-product-tabs__panel').forEach(function (panel) {
			panel.classList.toggle(
				'is-active',
				panel.getAttribute('data-panel-index') === index
			);
		});
	});
})();